import React from 'react';
// import UserCard from '../ProfileCard';
import { Helmet } from 'react-helmet'
import * as SG from '../../../constants/AppSettings'
import * as RT from '../../../constants/Routing'
import { Link } from 'react-router-dom'
// import defaultPhoto from '../../../lib/images/default-back.jpg'
import defaultUserPhoto from '../../../lib/images/user-thumb-default.png'
import CircleListItem from '../../Community/ListItem'

export default class Component extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      communityType: 'belong'
    }
  }

  componentWillMount = () => {
    const userId = this.props.match.params.id
    this.props.userInfoGet(userId)
    this.props.userCircleGet(userId)
  }

  componentWillUnmount = () => {
    this.props.userInfoGetReset()
  }

  onSubmit = (e) => {
    e.preventDeflt();
  }

  communityTypeChange = () => {
    let nextType
    if (this.state.communityType === 'belong') {
      nextType = 'own'
    } else {
      nextType = 'belong'
    }

    this.setState({ communityType: nextType })
  }

  generateAge = (int) => {
    if (isNaN(int)) {
      return '年代不明'
    } else {
      return `${Math.floor(int / 10) * 10}代`
    }
  }

  generateGender = (str) => {
    switch (str) {
      case 'male':
        return '男性'
      case 'female':
        return '女性'
      default:
        return '性別不明'
    }
  }

  render = () => {
    const selectedUser = this.props.UserShow.selectedUser
    const usersCommunities = this.props.UserShow.usersCommunities
    const currentUser = this.props.App.currentUser
    let photo = defaultUserPhoto, name = "　　　　　",
      messageLink = (
        <Link to={RT} className='btn btn-circle toMsgBtn disable' disable={true}>
          <i className="material-icons">chat_bubble</i>
        </Link>
      ),
      hostCount = 0, belongCount = 0,
      communities = (
        <CircleListItem key={0} />
      ), age, gender

    if (!!selectedUser) {
      photo = (selectedUser.photo) ? selectedUser.photo : defaultUserPhoto
      name = (selectedUser.name) ? selectedUser.name : "　　　　"
      age = this.generateAge(selectedUser.age)
      gender = this.generateGender(selectedUser.gender)
      messageLink = (
        <Link to={RT.MESSAGE_ROOM_PATH.replace(/:id/, selectedUser.id)} className='btn btn-circle toMsgBtn'>
          <i className="material-icons">chat_bubble</i>
        </Link>
      )

      if (!!usersCommunities) {
        const belong = usersCommunities.belong
        const owns = usersCommunities.own
        if (this.state.communityType === 'belong') {
          if (belong.length > 0) {
            communities = belong.map(circle => {
              return (
                <CircleListItem key={circle.id} circle={circle} />
              )
            })
          } else {
            communities = (
              <div>
                参加中のサークルはありません
              </div>
            )
          }
        } else {
          if (owns.length > 0) {
            communities = owns.map(circle => {
              return (
                <CircleListItem key={circle.id} circle={circle} />
              )
            })
          } else {
            communities = (
              <div>
                作成中のサークルはありません
              </div>
            )
          }
        }
        hostCount = owns.length
        belongCount = belong.length
      } else {
        if (this.props.UserShow.communityLoaded) {
          if (this.state.communityType === 'belong') {
            communities = (
              <div>
                参加中のサークルはありません
              </div>
            )
          } else {
            communities = (
              <div>
                作成したサークルはありません
              </div>
            )
          }

        }
      }

      if (currentUser) {
        if (currentUser.id === selectedUser.id) {
          messageLink = (
            <Link to={RT.USER_MYPAGE_PATH} className='btn btn-circle toMsgBtn'>
              <i className="material-icons">person</i>
            </Link>
          )
        }
      }
    }

    

    const thumbStyle = {
      backgroundImage: `url(${photo})`,
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      width: '80px',
      height: '80px',
      margin: '0 auto 0',
      borderRadius: '50%'
    }
    const metaInfo = (
      <Helmet>
        <title>{`${name}`}さんの詳細ページ | {SG.META_TITLE}</title>
        <meta name='description' content={`サークルー(circrew)ユーザーの${name}さんの詳細ページです。`} />
      </Helmet>
    )
    
    return (
      <div className='container'>
        {metaInfo}
        <div className='mypage-card'>
          <div className='user-mypage-header row pt15 pb5'>
            <div className='col-4'>
              <div className='user-thumb-form shadow-sm' style={thumbStyle}></div>
            </div>
            <div className='col-8'>
              <div className='user-profile-box'>
                <p className='user-name'>{name}</p>
                <p>{gender}</p>
                <p>{age}</p>
              </div>
            </div>
            {messageLink}
          </div>
          <ul className='float-menu mb30 row'>
            <li className='col-6' onClick={this.communityTypeChange}><a className={this.state.communityType === 'belong' ? ' active' : ''}>参加サークル<span className='circle-count'>({belongCount})</span></a></li>
            <li className='col-6' onClick={this.communityTypeChange}><a className={this.state.communityType === 'own' ? ' active' : ''}>作成サークル<span className='circle-count'>({hostCount})</span></a></li>
          </ul>
        </div>

        <div>
          {communities}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/User/Show/Show.jsx